import { useQuery } from '@tanstack/react-query';

import decodeJson from '@seccon/shared/utils/decodeJson';
import ApiError from '@seccon/shared/utils/ApiError';

/**
 * Fetches the contract information
 * @param {} context - react query context
 * @returns {Promise<object>} - CurrentUser information
 */

function fetchTravelReason () {
  return fetch('/referenceData/getDropdownOptions?dropdown=incident.foreignTravelReason.status')
    .then(decodeJson)
    .catch(({ body, status }) => {
      if (status === 404) {
        throw new ApiError('Unable to get the mode of transportation');
      }
      throw new ApiError(body ? `Error: ${ body }` : 'Unable to the reasone of travel. Please reload the page and try again');
    });
}

const useTravelReason = () => {
  const value = useQuery({
    queryKey: ['useTravelReason'],
    queryFn: fetchTravelReason,
    refetchOnWindowFocus: false,
    staleTime: Infinity
  });
  return value;
};

export default useTravelReason;
